/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { MaybeMap } from './map';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function defaultdict(factory) {
    return new Proxy({}, {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        get(target, key, receiver) {
            if (!Reflect.has(target, key)) {
                Reflect.set(target, key, factory(key), receiver);
            }
            return Reflect.get(target, key, receiver);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        set(target, key, value, receiver) {
            return Reflect.set(target, key, value, receiver);
        },
    });
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class DefaultMap {
    factory;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _map = new Map();
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(factory) {
        this.factory = factory;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get(key) {
        if (!this._map.has(key)) {
            this._map.set(key, this.factory(key));
        }
        return this._map.get(key);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    has(key) {
        return this._map.has(key);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    forEach(callbackfn, thisArg) {
        this._map.forEach((value, key) => callbackfn(value, key, this), thisArg);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get size() {
        return this._map.size;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    entries() {
        return this._map.entries();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    keys() {
        return this._map.keys();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    values() {
        return this._map.values();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    [Symbol.iterator]() {
        return this._map[Symbol.iterator]();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    map(fun) {
        const m = new Map();
        for (const [key, val] of this) {
            m.set(key, fun(val, key));
        }
        return m;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    toMaybeMap() {
        return new MaybeMap(this.entries());
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get [Symbol.toStringTag]() {
        return this._map[Symbol.toStringTag];
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class MutableDefaultMap extends DefaultMap {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    set(key, value) {
        this._map.set(key, value);
        return this;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    delete(key) {
        return this._map.delete(key);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    clear() {
        this._map.clear();
    }
    /**
     * Mutate a key in this map.
     *
     * @param key The key to mutate.
     * @param updater The function to update and create the new value. It is given the old value as
     * it sole argument.
     * @returns The old value of the map.
     */
    mutate(key, updater) {
        const old = this.get(key);
        this.set(key, updater(old));
        return old;
    }
}
